import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store';
import { setupAxios, setupVueCountdown, setupNotification, setupVueSvgIcon, setupVueFinalModal } from '@/plugins';

import '@/assets/tailwind.css';
import '@/router/permission'; // permission control 全局路由守衛
import Loading from '@/components/Loading.vue';

const app = createApp(App);
const setupPlugins = () => {
    setupNotification(app);
    setupAxios(app);
    setupVueCountdown(app);
    setupVueSvgIcon(app);
    setupVueFinalModal(app);
};

setupPlugins();

app.component('Loading', Loading);
app.use(store).use(router);
router.isReady().then(() => app.mount('#app'));
